<a *ngIf="url" mat-icon-button [href]="url" target="_blank" (click)="$event.stopPropagation()">
  <mat-icon>{{Icons.ACTION_OPEN_NEW_TAB}}</mat-icon>
</a>
{{label}}
